import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "../screens/Login";
import Error404 from "../screens/Error";
import NavBar from "./NavBar";
import ChooseBill from "../screens/ChooseBill";
// import HtmlPage from "../screens/HtmlPage";


function Nav() {
    return (
    <Router>
            <Switch>
              <Route exact path='/' component={Login} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/chooseBill' component={ChooseBill}/>
              <Route exact path='/home' component={NavBar} />
              <Route exact path='/cookieConsent' component={NavBar} />
              <Route exact path='/scanReport' component={NavBar} />
              <Route exact path='/cookiePreferenceCenter' component={NavBar} />
              <Route exact path='/cookieConsentLogs' component={NavBar}/>
              {/* <Route exact path='/createtemplate' component={NavBar} /> */}
              <Route exact path='/createConsentGroup/:page' component={NavBar} />
              <Route exact path='/profile' component={NavBar}/>
              <Route exact path='/customizePreferenceCenter' component={NavBar}/>
              <Route exact path='/faqs' component={NavBar}/>
              <Route exact path='/templatelist/:from' component={NavBar}/>
              <Route exact path='/datatype' component={NavBar}/>
              <Route exact path='/purpose' component={NavBar}/>
              <Route exact path='/consentgroup' component={NavBar}/>
              <Route exact path='/consentBulkUpload' component={NavBar}/>
              {/* <Route exact path="/template"  component={HtmlPage} /> */}


              <Route component={Error404}/>
            </Switch>
      </Router>
    );
  }
  
  export default Nav;